<template>
  <ButtonBase button-type="primary">
    <template #button>
      <slot></slot>
    </template>
  </ButtonBase>
</template>

<script setup>
import ButtonBase from "./_base/ButtonBase.vue"
</script>
